import StoniTenis from './StoniTenis'

const Bilijar = () => <StoniTenis calculatorType='Bilijar' />

export default Bilijar
